module.exports = __webpack_public_path__ + "static/img/t5@2x.ca9e9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/picture/t5@2x.png
// module id = 031i
// module chunks = 1